// extracted by mini-css-extract-plugin
export default {"container":"ExportCard_container__5M1wd","content":"ExportCard_content__IohMd"};